// src/components/mitchRoom/modelOutputs/gridUtils.js
// Shared helpers for the Team/Player Results grids. Colour conventions are
// ported from web-app (FDR soft-colour formula, Playing History points ramp).

/**
 * FDR win-probability colour ramp (web-app convention, 0-100 input).
 */
export const getWinColor = (percent) => {
  if (percent == null) return '#cccccc';
  if (percent > 45) return '#4caf50'; // Green
  if (percent >= 30) return '#ff9800'; // Orange
  return '#f44336'; // Red
};

/**
 * The web-app "soft colour" formula: full-strength hex softened by alpha
 * suffixes (25% fill, 50% border). Text stays near-black — the colour never
 * carries the text.
 */
export const softStyle = (color) => ({
  backgroundColor: `${color}40`,
  border: `1px solid ${color}80`,
});

/**
 * FPL points badge ramp (web-app Playing History convention).
 */
export const pointsClasses = (pts) => {
  if (pts == null) return '';
  if (pts <= 0) return 'bg-neutral-200 text-neutral-600';
  if (pts <= 2) return 'bg-neutral-300 text-neutral-700';
  if (pts <= 5) return 'bg-sky-100 text-sky-800';
  if (pts <= 9) return 'bg-emerald-100 text-emerald-800';
  return 'bg-emerald-600 text-white';
};

const ABBREV_STOPWORDS = new Set(['fc', 'afc', 'cf', 'sc', 'ac', 'de', 'the', 'and', '1']);

/**
 * Fallback three-letter code for clubs missing from the FPL bootstrap
 * (relegated/historical sides), e.g. "Leicester City" -> "LEI".
 */
export const abbreviate = (name) => {
  if (!name) return '?';
  const words = name
    .replace(/[^\p{L}\p{N} ]/gu, ' ')
    .split(/\s+/)
    .filter((w) => w && !ABBREV_STOPWORDS.has(w.toLowerCase()));
  if (!words.length) return '?';
  return words[0].slice(0, 3).toUpperCase();
};

/**
 * Opponent label with home/away encoded by casing (web-app FDR convention):
 * ARS = home fixture, ars = away fixture.
 */
export const oppLabel = (shortName, homeAway) =>
  homeAway === 'A' ? (shortName || '?').toLowerCase() : (shortName || '?').toUpperCase();

/** Whole-number percent, prob input on the 0-100 scale. */
export const pct = (value) => (value == null ? '–' : `${Math.round(value)}`);

/** Whole-number percent, prob input on the 0-1 scale. */
export const pct01 = (value) => (value == null ? '–' : `${Math.round(value * 100)}`);
